import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { Observable } from "rxjs";
import { HttpclientService } from "../../../../../shared";

@Injectable()
export class VoidTransactionService {
	constructor(private httpclientService: HttpclientService) {}

	LastTransactionGet(PersonID, SchoolID) {
		var postResult$ = new Subject();
		var url = "attendance/LastTransactionGet?&PersonID=" + PersonID + "&SchoolID=" + SchoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});

		return postResult$;
	}

	TransactionVoid(transactionID) {
		var postResult$ = new Subject();
		var url = "attendance/TransactionVoid?PointsTransactionID=" + transactionID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
